'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';

const BadRequestError = ({
  className,
  resetLink
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  className: classNames('bad-request-error', className),
  "data-test-id": "bad-request-error",
  type: "badRequest",
  children: [/*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.errors.badRequest.somethingsGoneWrong"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.errors.badRequest.refreshPage"
    })]
  }), !!resetLink && /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.errors.filters.common.subtitle"
    }), /*#__PURE__*/_jsx(UIRouterLink, {
      to: resetLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.errors.filters.common.clearFilters"
      })
    })]
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.errors.badRequest.keepsHappening"
    })
  })]
});

BadRequestError.propTypes = {
  className: PropTypes.string,
  resetLink: PropTypes.string
};
export default BadRequestError;